import { render } from "./MediaAdded.vue?vue&type=template&id=04a03bce"
import script from "./MediaAdded.vue?vue&type=script&lang=js"
export * from "./MediaAdded.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__